import * as R from 'ramda'
import { ClientOffer, ContractFilenames, Offer, OfferPreviousVersion } from 'app/types/types'

import { isOfferUnsaved, mergeOfferChanges } from './utils'
import { getOfferByOpportunityId } from './opportunity-utils'
import { updateOfferAsync } from '../redux/features/currentOffer/update-offer-async'

export const unsavedOffersCount = (offers: Offer[]) => R.pipe(R.filter(isOfferUnsaved), R.length)(offers)

export const setContractIntroduction =
  (language: string, introduction: string) =>
  (offer: Offer): Offer => {
    const introductions = R.assoc(language, introduction, offer.introductions)
    return { ...offer, introductions }
  }

export const isOfferingInprogress = (offer: Offer): boolean => {
  if (R.isNil(offer) || R.isEmpty(offer)) {
    return false
  }
  const { tenderVersionId, prices } = offer
  return R.isNil(tenderVersionId) && !R.isEmpty(prices)
}

export const updateRecreatedDocuments =
  (enablerFilename: string, contractFilenames: ContractFilenames, previousVersions: OfferPreviousVersion[]) =>
  (offer: ClientOffer): ClientOffer => ({
    ...offer,
    enablerFilename,
    contractFilenames,
    previousVersions
  })

export const opportunitiesChanged = (opportunityIds: string[], dispatch: any) => {
  const currentOpportunityId = sessionStorage.getItem('opportunityId')

  if (currentOpportunityId != null && R.indexOf(currentOpportunityId, opportunityIds) !== -1) {
    getOfferByOpportunityId(currentOpportunityId)
      .then(updatedOffer => {
        dispatch(updateOfferAsync(offer => (updatedOffer != null ? mergeOfferChanges(offer, updatedOffer) : offer)))
      })
      .catch(error => {
        console.error('Error fetching updated offer:', error)
      })
  }
}

export const updateContractEmailTimestamp =
  (offerVersionId: string, contractEmailTimestamp: string) =>
  (offer: ClientOffer): ClientOffer => {
    /* Find correct previous version that was updated */
    const previousVersions = offer.previousVersions.map(p =>
      p.id === offerVersionId
        ? {
            ...p,
            contractEmailTimestamp
          }
        : p
    )

    if (offer.id === offerVersionId) {
      /* For active version we must update previous versions and active offer */
      return {
        ...offer,
        previousVersions,
        contractEmailTimestamp
      }
    } else {
      /* For non active, it's enough to just update previous version */
      return {
        ...offer,
        previousVersions
      }
    }
  }

export const updateContractFilenames =
  (offerVersionId: string, contractDocuments: ContractFilenames) =>
  (offer: ClientOffer): ClientOffer => {
    const newGenDoc = contractDocuments.gendoc
    const prevVersion = offer.previousVersions.find(o => o.id === offerVersionId)

    if (!prevVersion) {
      return offer
    }

    const contractFilenames = {
      gendoc: {
        ...prevVersion.contractFilenames.gendoc,
        ...newGenDoc
      }
    }

    /* Find correct previous version that was updated */
    const previousVersions = offer.previousVersions.map(p =>
      p.id === offerVersionId
        ? {
            ...p,
            contractFilenames
          }
        : p
    )

    if (offer.id === offerVersionId) {
      /* For active version we must update previous versions and active offer */
      return {
        ...offer,
        contractFilenames,
        previousVersions
      }
    } else {
      /* For non active, it's enough to just update previous version */
      return {
        ...offer,
        previousVersions
      }
    }
  }
